module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_c2/sec05_pc_6d833f279d995e9432b54e4b1fb9c47a.png";